import { Box, Typography } from '@mui/material';
import { FieldProps } from 'formik';

import { FormPart } from '@modules/shared/components/FormPart';
import { mapGridIndexes } from '@shared/commonFunctions';
import { dataGridCol } from '@shared/components/grid/common';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper, Wrapper } from '@styles/CommonStyles';
import { colorTheme } from '@styles/muiTheme';
import { columnData } from '@modules/admin/Tools/LenderUtility/tabs/DocFees/DocFeesTable/interfaces';

import { IFormulaFormProps, stateProductRestrictionFormulaExamples } from '../interfaces';

interface IRenderField extends FieldProps {
  label: string;
}

const RenderField = ({ field, label }: IRenderField) => {
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      gap={1}
      pl={1}
    >
      <Typography
        width="6%"
        fontSize="11px"
        fontWeight={600}
      >
        {label}:
      </Typography>
      <Typography
        width="94%"
        fontWeight={600}
        color={colorTheme.palette.primary.main}
      >
        {field?.value ?? ''}
      </Typography>
    </Box>
  );
};

export const exampleColumns = [
  dataGridCol('description', {
    textWrap: true,
  }),
  dataGridCol('formula', {
    textWrap: true,
  }),
].map((column) => ({ ...column, flex: 1, resizable: false }));

const formPart = [
  {
    name: 'state',
    label: 'State',
    width: '100%',
    component: RenderField,
  },
  {
    name: 'maxAllowedFormula',
    label: 'Formula',
    width: '100%',
  },
];

const columns = [
  dataGridCol('name', {
    width: 100,
  }),
  dataGridCol('description', {
    flex: 1,
  }),
  dataGridCol('syntax', {
    flex: 1,
  }),
].map((column) => ({ ...column }));

export const ProductRestrictionsFormulaForm = ({ handleClose, loading }: IFormulaFormProps) => {
  return (
    <>
      <FormPart config={formPart} />

      <Wrapper>
        <PhoenixGrid
          noButton
          withHeader
          autoHeight
          hideFooter
          disableSelectionOnClick
          name="Formula Function"
          pageSize={15}
          columns={columns}
          rows={mapGridIndexes(columnData)}
        />
      </Wrapper>
      <Wrapper>
        <PhoenixGrid
          noButton
          withHeader
          autoHeight
          hideFooter
          isFlexible
          autoRowHeight
          disableSelectionOnClick
          name="Formula Example"
          pageSize={15}
          columns={exampleColumns}
          rows={mapGridIndexes(stateProductRestrictionFormulaExamples)}
        />
      </Wrapper>
      <CommonButtonWrapper sx={{ position: 'relative', top: '20px', marginBottom: '20px' }}>
        <CancelButton
          label="Cancel"
          onClick={handleClose}
        />
        <SaveButton isLoading={loading} />
      </CommonButtonWrapper>
    </>
  );
};
